import { keepPreviousData } from '@tanstack/react-query';

import { Filter, SortDirection } from '@playq/octopus-common';
import { AppsSort, AppsSortField, QueryAppsResponse } from '@playq/octopus2-apps';
import { GenericFailure, OffsetLimit } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { iteratorMaxLimit } from '/constants';

const appsSortBy = [new AppsSort({ ord: SortDirection.None, field: AppsSortField.ID })];

export const adminCompanyLookupQuery: unknown[] = ['admin', 'company', 'service', 'getCompanyApps'];
export const useAdminCompanyLookupQuery = (
  company: number,
  sortBy: AppsSort[] = appsSortBy,
  iterator: OffsetLimit = new OffsetLimit({ offset: 0, limit: iteratorMaxLimit }),
  filterBy: {
    [key: string]: Filter;
  } = {},
  options?: IUseQueryOptionsExtended<QueryAppsResponse | undefined, GenericFailure | Error>
) => {
  const res = useEitherQuery(
    adminCompanyLookupQuery.concat(company, iterator, sortBy, filterBy),
    () => {
      return services2.adminCompanyLookupService.getCompanyApps(company, iterator, sortBy, filterBy);
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );
  const entities = res.data instanceof QueryAppsResponse ? res.data.entities : [];
  return { ...res, entities };
};
